import { Controller } from "@hotwired/stimulus"

const DONE_LABEL_DURATION = 2000

export default class extends Controller {
  static values = {
    copy: String,
    doneLabel: String
  }
  async copy() {
    if (!this.copyValue) return

    try {
      await navigator.clipboard.writeText(this.copyValue)
      this.showFeedback()
    } catch (err) {
      console.error(err.name, err.message)
    }
  }

  showFeedback() {
    if (!this.doneLabelValue || this.revertTimeout) return

    const idleLabel = this.element.textContent
    this.element.textContent = this.doneLabelValue
    this.revertTimeout = setTimeout(() => {
      this.element.textContent = idleLabel
      this.revertTimeout = null
    }, DONE_LABEL_DURATION)
  }

  disconnect() {
    clearTimeout(this.revertTimeout)
  }
}
